<template>
  <svg
    width="16"
    height="16"
    viewBox="0 0 16 16"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M7.9998 15.1998C11.9763 15.1998 15.1998 11.9763 15.1998 7.99981C15.1998 4.02336 11.9763 0.799805 7.9998 0.799805C4.02335 0.799805 0.799805 4.02336 0.799805 7.99981C0.799805 11.9763 4.02335 15.1998 7.9998 15.1998Z"
      stroke="currentColor"
      stroke-width="1.5"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
    <path
      d="M5.83984 5.48326C6.00912 5.00206 6.34323 4.5963 6.78301 4.33784C7.22279 4.07938 7.73985 3.9849 8.24261 4.07113C8.74537 4.15737 9.20139 4.41876 9.5299 4.809C9.85841 5.19924 10.0382 5.69316 10.0374 6.20326C10.0374 7.64326 7.87744 8.36326 7.87744 8.36326V9.80326"
      stroke="currentColor"
      stroke-width="1.5"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
    <ellipse
      cx="7.93484"
      cy="11.9632"
      rx="0.72"
      ry="0.720001"
      fill="currentColor"
    />
  </svg>
</template>

<script>
export default {};
</script>
